import { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import styles from "./profile.module.css";

type TProfileMenuLayoutProps = {
  children: ReactNode;
};

export function ProfileMenuLayout({ children }: TProfileMenuLayoutProps): JSX.Element {
  return (
    <div className={styles.layout}>
      <nav className={styles.menu} aria-label="profile sections">
        <NavLink
          to=""
          end
          className={({ isActive }) =>
            isActive ? `${styles.menuLink} ${styles.menuLinkActive}` : styles.menuLink
          }
        >
          <span className={styles.menuIcon} aria-hidden="true">
            <svg className={styles.menuIconSvg} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 12C14.7614 12 17 9.76142 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.76142 9.23858 12 12 12Z" stroke="currentColor" strokeWidth="1.8"/>
              <path d="M4 21C4 17.6863 7.58172 15 12 15C16.4183 15 20 17.6863 20 21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </span>
          <span>Profile</span>
        </NavLink>

        <NavLink
          to="statistics"
          className={({ isActive }) =>
            isActive ? `${styles.menuLink} ${styles.menuLinkActive}` : styles.menuLink
          }
        >
          <span className={styles.menuIcon} aria-hidden="true">
            <svg className={styles.menuIconSvg} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 19H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              <path d="M7 15V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              <path d="M12 15V8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              <path d="M17 15V5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
          </span>
          <span>Statistics</span>
        </NavLink>
      </nav>

      <div className={styles.content}>{children}</div>
    </div>
  );
}